import { ControllerWrapper, ExtendedUseFormReturn } from '@Hooks/index';
import { OwnerFormFields } from '@Pages/happyFlowPages/addOwner/hooks/useAddOwnerLogic.ts';
import { OnboardingFormFields } from '@Types/index.ts';
import { FontWeight, Heading, LiliNumberInput } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { useAddOwnerAnalytics } from '@Pages/happyFlowPages/addOwner/AddOwnerAnalytics.tsx';

export interface OwnerAccessProps {
  formMethods: ExtendedUseFormReturn<OwnerFormFields>;
}
export const OwnerAccess = ({ formMethods }: OwnerAccessProps) => {
  const { reportActOnAddOwner } = useAddOwnerAnalytics();
  const { t } = useTranslation();
  const basicButtonStyle = 'px-[40px] py-[18px] rounded-[8px] border-[1px]';
  const selectedButtonStyle =
    'bg-surface-brand-action-00 border-outline-brand-primary text-text-main-secondary';
  const unselectedButtonStyle =
    'bg-surface-primary-bw-00 border-outline-primary-bw-06 hover:border-outline-brand-primary hover:bg-surface-primary-bw-01';
  const options = [true, false];
  return (
    <div className='mt-[7px] pt-[32px] border-t-[1px] border-t-outline-primary-bw-03'>
      <ControllerWrapper name={OnboardingFormFields.OWNER_PERCENTAGE}>
        {({ value, onBlur, onChange, error }) => (
          <LiliNumberInput
            id={OnboardingFormFields.OWNER_PERCENTAGE}
            title={t('pages.addOwner.ownerAccessSection.ownershipPercentageInput')}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            errorMessage={error?.message}
            min={0}
            max={100}
            suffix='%'
            maxLength={3}
          />
        )}
      </ControllerWrapper>

      <div className=' w-full bg-surface-primary-bw-02 px-[16px] py-[24px] rounded-xl'>
        <Heading.H8
          fontWeight={FontWeight.SEMIBOLD}
          className='mb-[16px] text-text-main-secondary border-outline-brand-primary'>
          {t('pages.addOwner.ownerAccessSection.accessTitle')}
        </Heading.H8>
        <div className='flex flex-row gap-4 '>
          {options.map((option) => (
            <ControllerWrapper name={OnboardingFormFields.OWNER_ACCESS_GRANTED} key={`${option}`}>
              {({ value }) => (
                <button
                  role='button'
                  id={`${option ? 'grantAccessYesButton' : 'grantAccessNoButton'}`}
                  className={twMerge(
                    basicButtonStyle,
                    value === option ? selectedButtonStyle : unselectedButtonStyle
                  )}
                  onClick={() => {
                    reportActOnAddOwner(option);
                    formMethods.setValue(OnboardingFormFields.OWNER_ACCESS_GRANTED, option);
                  }}>
                  <Heading.H10
                    fontWeight={FontWeight.MEDIUM}
                    className={`${option === value && 'text-text-brand-primary'}`}>
                    {option
                      ? t('pages.addOwner.ownerAccessSection.allowAccessOption')
                      : t('pages.addOwner.ownerAccessSection.disableAccessOption')}
                  </Heading.H10>
                </button>
              )}
            </ControllerWrapper>
          ))}
        </div>
      </div>
    </div>
  );
};
